var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import * as fromStore from '../../_store';
import { Store } from '@ngrx/store';
import { DOCUMENT_NUMBER_NATIONAL_IDENTITY_CARD, DOCUMENTS_NUMBER_PASSPORT, PAX_TYPE_INFANT_CODE, PAX_TYPE_CHILD_CODE, PAX_TYPE_YOUNG_ADULT_CODE, DOCUMENT_NUMBER_PASSPORT, COUNTRY_CODE_CANADA, COUNTRY_CODE_COLOMBIA } from '@ibe.config';
import * as _ from 'lodash';
import { take } from 'rxjs/operators';
import * as fromGlobalStore from '@ibe/store/index';
import { ValidatorsApp } from '@ibe.components/shared/_validators';
import { Router } from '@angular/router';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var PassengerDetailPersonalDocumentsComponent = /** @class */ (function () {
    function PassengerDetailPersonalDocumentsComponent(fb, store, globalStore, router, ibeAdminService) {
        this.fb = fb;
        this.store = store;
        this.globalStore = globalStore;
        this.router = router;
        this.ibeAdminService = ibeAdminService;
        this.displayValidationMessages = false;
        this.departureDate = "";
        this.isUKDestination = false;
        this.isCAorCODestination = false;
        this.form = this.fb.group({
            country: [null, Validators.required],
            docNum: [null, [Validators.required, Validators.pattern('[a-zA-Z0-9]+')]],
            docType: [null, Validators.required],
            expiryDate: [null, Validators.required],
            nationallity: [null, Validators.required],
            birthDate: [null],
            lifelong: [false],
            stateOrProvinceCode: [null],
            address: [null],
            postalCode: [null],
            city: [null],
            redress: [null, [Validators.maxLength(7), Validators.pattern('[0-9]+')]],
            infant: [false],
            gender: [null]
        });
        this.isBookingPaymentPage = false;
        this.euCountryCodes = [];
        this.schengenCountryCodes = [];
        this.locations = [];
        this.sub$ = new Subscription();
        this.usAirports = [];
        this.documentTypes = [];
        this.countryCodes = [];
        this.usStates = [];
        this.documentTypesOptions = [];
        this.genderCodes = [
            { text: 'bookingDetails.label.male', value: 'Male' },
            { text: 'bookingDetails.label.female', value: 'Female' }
        ];
        this.isUSDestination = false;
        this.verifyOnlyPassport = false;
        this._hasChanges = new BehaviorSubject(false);
        this.isCanadaDestination = false;
        this.isOptionalPassportDestination = false;
    }
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "passengerInfo", {
        get: function () {
            return this._passengerInfo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasChanges", {
        get: function () {
            return this._hasChanges.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "classViewOnlyForm", {
        get: function () {
            return Object.is('view', this.displayMode) ? 'sidebar__form--view-only' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrorClassDocType", {
        get: function () {
            return this.form.get('docType').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrorClassDocNum", {
        get: function () {
            return this.form.get('docNum').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrorClassCountry", {
        get: function () {
            return this.form.get('country').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrorClassNationallity", {
        get: function () {
            return this.form.get('nationallity').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrorClassGender", {
        get: function () {
            return this.form.get('gender').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrorClassStateOrProvinceCode", {
        get: function () {
            return this.form.get('stateOrProvinceCode').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrorClassAddress", {
        get: function () {
            return this.form.get('address').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrorClassPostalCode", {
        get: function () {
            return this.form.get('postalCode').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrorClassCity", {
        get: function () {
            return this.form.get('city').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrorClassRedress", {
        get: function () {
            return this.form.get('redress').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasData", {
        get: function () {
            return !_.isEmpty(this.form.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "hasErrors", {
        get: function () {
            return !_.isEmpty(this.form.errors);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "lifelong", {
        get: function () {
            return this.form.get('lifelong').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "isInfant", {
        get: function () {
            return Object.is(PAX_TYPE_INFANT_CODE, this.passengerInfo.typePax);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "isChild", {
        get: function () {
            return Object.is(PAX_TYPE_CHILD_CODE, this.passengerInfo.typePax);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailPersonalDocumentsComponent.prototype, "isYoungAdult", {
        get: function () {
            return Object.is(PAX_TYPE_YOUNG_ADULT_CODE, this.passengerInfo.typePax);
        },
        enumerable: true,
        configurable: true
    });
    PassengerDetailPersonalDocumentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think/payment')) {
            this.isBookingPaymentPage = true;
        }
        this.sub$.add(this.store.select(fromStore.getSelectedBookedTripLocations).subscribe(function (data) { return _this.locations = Object.values(data); }));
        this.sub$.add(this.globalStore.select(fromGlobalStore.getSelectedCountryCodesOpts).subscribe(function (data) {
            if (data && data.length) {
                _this.countryCodes = _this.INDRA_getCountryCodesOptions(data);
            }
        }));
        // WE NEED THIS TO CONVERT RESULT OF TRAVEL DOCUMENT TO ACCEPTED FORMAT
        this.sub$.add(this.globalStore.select(fromGlobalStore.getSelectedCountryConversionCodes).subscribe(function (data) {
            return _this.countryConversionCodesMap = _.chain(data).keyBy('alpha_3_code').mapValues('alpha_2_code').value();
        }));
        this.sub$.add(combineLatest([
            this.store.select(fromStore.getSelectedDocumentTypes),
            this.globalStore.select(fromGlobalStore.getSelectedUSAirports),
            this.store.select(fromStore.getSelectedBookedTripFare),
            this.store.select(fromStore.getSelectedPassengersAtIndex),
            this.globalStore.select(fromGlobalStore.getSelectedSchengenCountryCodes),
            this.globalStore.select(fromGlobalStore.getSelectedEUCountryCodes),
            this.store.select(fromGlobalStore.getSelectedUSStates)
        ]).subscribe(function (_a) {
            var docTypes = _a[0], usAirports = _a[1], bookedTripFare = _a[2], passenger = _a[3], schengenCountryCodes = _a[4], euCountryCodes = _a[5], usStates = _a[6];
            if (passenger) {
                _this._passengerInfo = passenger;
                _this.documentTypes = docTypes;
                _this.usAirports = usAirports;
                _this.schengenCountryCodes = schengenCountryCodes;
                _this.euCountryCodes = euCountryCodes;
                _this.usStates = usStates;
                _this.isCAorCODestination = _this.verifyIfCanadaOrColombia();
                // passport is required for UK destinations
                if (_this.isUKDestination) {
                    _this.verifyOnlyPassport = true;
                }
                else if (_this.isCAorCODestination) {
                    _this.verifyOnlyPassport = true;
                }
                else {
                    _this.verifyOnlyPassport = _this.verifyIfRouteRequiresOnlyPassport();
                }
                _this.documentTypesOptions = _this.mapDocTypeListToSelectOptions(docTypes);
                _this.isUSDestination = bookedTripFare.listOutbound.map(function (lo) { return lo.listSegment.map(function (ls) { return ls.arrivalAirport; }); }).concat(bookedTripFare.listInbound.map(function (li) { return li.listSegment.map(function (ls) { return ls.arrivalAirport; }); })).some(function (vio) { return _this.usAirports.some(function (us) { return vio.includes(us.code); }); });
                _this.isCanadaDestination = bookedTripFare.listOutbound.map(function (lo) { return lo.listSegment.map(function (ls) { return ls.arrivalAirport; }); }).concat(bookedTripFare.listInbound.map(function (li) { return li.listSegment.map(function (ls) { return ls.arrivalAirport; }); })).some(function (airports) { return _this.locations.some(function (loc) { return airports.includes(loc.code) && loc.countryCode == COUNTRY_CODE_CANADA; }); });
                _this.isOptionalPassportDestination = _this.isUSDestination || _this.isCanadaDestination ? true : false;
                _this.mapPassengerToForm(passenger);
                _this.updateFormValidation();
                _this.verifyFormValidations();
                _this.verifyDisplayMode();
            }
        }));
        this.sub$.add(this.form.valueChanges.subscribe(function () { return _this._hasChanges.next(true); }));
        this.formValueChangesUpdateRedress();
        this.formValueChangesUpdateDocument();
        this.formValueChangesUpdateDOCA();
    };
    PassengerDetailPersonalDocumentsComponent.prototype.updateFormValidation = function () {
        if (!this.isInfant && !this.isChild && !this.isYoungAdult) {
            this.form.get('gender').setValidators([Validators.required]);
            this.form.get('birthDate').setValidators([Validators.required]);
        }
        if (this.isOptionalPassportDestination) {
            this.form.get('docType').clearValidators();
            this.form.get('docNum').clearValidators();
            this.form.get('expiryDate').clearValidators();
            this.form.get('country').clearValidators();
            this.form.get('nationallity').clearValidators();
            this.form.get('docType').updateValueAndValidity({ emitEvent: false });
            this.form.get('docNum').updateValueAndValidity({ emitEvent: false });
            this.form.get('expiryDate').updateValueAndValidity({ emitEvent: false });
            this.form.get('country').updateValueAndValidity({ emitEvent: false });
            this.form.get('nationallity').updateValueAndValidity({ emitEvent: false });
        }
    };
    PassengerDetailPersonalDocumentsComponent.prototype.formValueChangesUpdateRedress = function () {
        var _this = this;
        this.form.get('redress').valueChanges.subscribe(function (value) {
            return _this.dispatchUpdateRedress(value);
        });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.dispatchUpdateRedress = function (value) {
        var obj = _.isNil(value) ? { 'updateRedress': false } : { 'updateRedress': true };
        this.store.dispatch(new fromStore.UpdateFormChangedAction(obj));
    };
    PassengerDetailPersonalDocumentsComponent.prototype.dispatchUpdateDocument = function () {
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateDocument': true }));
        if (this.isOptionalPassportDestination)
            this.INDRA_checkValidations();
    };
    PassengerDetailPersonalDocumentsComponent.prototype.dispatchUpdateDoca = function () {
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateDoca': true }));
    };
    PassengerDetailPersonalDocumentsComponent.prototype.formValueChangesUpdateDocument = function () {
        var _this = this;
        this.sub$.add(this.form.get('country').valueChanges.subscribe(function () { return _this.dispatchUpdateDocument(); }));
        this.sub$.add(this.form.get('docNum').valueChanges.subscribe(function () { return _this.dispatchUpdateDocument(); }));
        this.sub$.add(this.form.get('docType').valueChanges.subscribe(function () { return _this.dispatchUpdateDocument(); }));
        this.sub$.add(this.form.get('expiryDate').valueChanges.subscribe(function (value) { return _this.dispatchUpdateDocument(); }));
        this.sub$.add(this.form.get('nationallity').valueChanges.subscribe(function () { return _this.dispatchUpdateDocument(); }));
        this.sub$.add(this.form.get('lifelong').valueChanges.subscribe(function (value) {
            _this.verifyLifelongAndExpiryDateValidation(value);
            _this.dispatchUpdateDocument();
        }));
        if (!this.isInfant && !this.isChild && !this.isYoungAdult) {
            this.sub$.add(this.form.get('birthDate').valueChanges.subscribe(function () { return _this.dispatchUpdateDocument(); }));
            this.sub$.add(this.form.get('gender').valueChanges.subscribe(function () { return _this.dispatchUpdateDocument(); }));
        }
        // added since this passenger document is always required
        this.dispatchUpdateDocument();
    };
    PassengerDetailPersonalDocumentsComponent.prototype.verifyLifelongAndExpiryDateValidation = function (value) {
        var expiryDate = this.form.get('expiryDate');
        if (value) {
            this.form.get('expiryDate').patchValue(null);
            expiryDate.clearValidators();
        }
        else {
            if (!this.isOptionalPassportDestination) {
                expiryDate.setValidators(Validators.required);
            }
        }
        expiryDate.updateValueAndValidity({ emitEvent: false });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.formValueChangesUpdateDOCA = function () {
        var _this = this;
        this.sub$.add(this.form.get('stateOrProvinceCode').valueChanges.subscribe(function () { return _this.dispatchUpdateDoca(); }));
        this.sub$.add(this.form.get('address').valueChanges.subscribe(function () { return _this.dispatchUpdateDoca(); }));
        this.sub$.add(this.form.get('postalCode').valueChanges.subscribe(function () { return _this.dispatchUpdateDoca(); }));
        this.sub$.add(this.form.get('city').valueChanges.subscribe(function () { return _this.dispatchUpdateDoca(); }));
    };
    PassengerDetailPersonalDocumentsComponent.prototype.verifyFormValidations = function () {
        if (this.isUSDestination && !this.isBookingPaymentPage) {
            this.form.get('stateOrProvinceCode').setValidators([Validators.required]);
            this.form.get('stateOrProvinceCode').updateValueAndValidity({ emitEvent: false });
            this.form.get('address').setValidators([Validators.required, Validators.pattern('[a-zA-Z0-9_ ]+'), ValidatorsApp.no_whitespace]);
            this.form.get('address').updateValueAndValidity({ emitEvent: false });
            this.form.get('postalCode').setValidators([Validators.required, Validators.pattern('[a-zA-Z0-9_]+'), ValidatorsApp.no_whitespace]);
            this.form.get('postalCode').updateValueAndValidity({ emitEvent: false });
            this.form.get('city').setValidators([Validators.required, ValidatorsApp.no_whitespace]);
            this.form.get('city').updateValueAndValidity({ emitEvent: false });
            this.form.get('docNum').setValidators([Validators.required, Validators.pattern('[a-zA-Z0-9]+$'), ValidatorsApp.no_whitespace]);
            this.form.get('docNum').updateValueAndValidity({ emitEvent: false });
        }
        var lifelong = this.form.get('lifelong').value;
        this.verifyLifelongAndExpiryDateValidation(lifelong);
    };
    PassengerDetailPersonalDocumentsComponent.prototype.mapDocTypeListToSelectOptions = function (docTypes) {
        var documents = [DOCUMENT_NUMBER_PASSPORT];
        if (!this.verifyOnlyPassport) {
            documents = documents.concat(DOCUMENT_NUMBER_NATIONAL_IDENTITY_CARD);
        }
        return docTypes
            .filter(function (docT) { return docT.values.some(function (dv) { return documents.includes('' + dv); }); })
            .map(function (docT) { return ({
            text: docT.text,
            value: '' + docT.values.find(function (v) { return documents.some(function (vd) { return Object.is(v, +vd); }); })
        }); });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.getDocumentData = function (data) {
        return this.verifyOnlyPassport && !this.isOptionalPassportDestination ? data.listTravelDoc.find(function (doc) { return DOCUMENTS_NUMBER_PASSPORT.includes(doc.docType); }) : data.listTravelDoc[0];
    };
    PassengerDetailPersonalDocumentsComponent.prototype.mapPassengerToForm = function (data) {
        var document = this.getDocumentData(data);
        var formObject = this.getFormObject(document, data);
        if ((this.isInfant || this.isChild || this.isYoungAdult) && formObject && formObject['birthDate'] && formObject['gender']) {
            formObject['birthDate'] = null;
            formObject['gender'] = null;
        }
        this.form.patchValue(__assign({}, formObject), { emitEvent: false });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.verifyDisplayMode = function () {
        if (this.hasData && this.form.valid) {
            this.displayMode = this.isBookingPaymentPage ? 'edit' : 'view';
        }
        else {
            this.displayMode = 'edit';
        }
    };
    // WE NEED THIS TO CONVERT RESULT OF TRAVEL DOCUMENT TO ACCEPTED FORMAT
    PassengerDetailPersonalDocumentsComponent.prototype.updateCountriesByConversionArray = function (document) {
        var countryConverted;
        var nationalityConverted;
        if (document.country && document.country.length) {
            countryConverted = Object.is(document.country.length, 2)
                ? document.country : this.countryConversionCodesMap[document.country];
        }
        if (document.nationallity && document.nationallity.length) {
            nationalityConverted = Object.is(document.nationallity.length, 2)
                ? document.nationallity : this.countryConversionCodesMap[document.nationallity];
        }
        return __assign({}, document, { country: countryConverted, nationallity: nationalityConverted });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.getFormObject = function (document, passenger) {
        var doc = !_.isNil(document) ? this.updateCountriesByConversionArray(document) : {}; // WE NEED THIS TO CONVERT RESULT OF TRAVEL DOCUMENT TO ACCEPTED FORMAT
        var typePax = passenger.typePax, address = passenger.address;
        return __assign({}, address, doc, { lifelong: this.isOptionalPassportDestination && _.has(doc, 'lifelong') ? document['lifelong'] : _.has(doc, 'expiryDate') && _.isEmpty(document.expiryDate), gender: _.has(doc, 'gender') ? doc.gender : null, infant: Object.is('INF', typePax) });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.ngOnDestroy = function () {
        this.sub$.unsubscribe();
    };
    PassengerDetailPersonalDocumentsComponent.prototype.trackByFn = function (index, item) {
        return index;
    };
    PassengerDetailPersonalDocumentsComponent.prototype.verifyIfRouteRequiresOnlyPassport = function () {
        var _this = this;
        return this.locations.some(function (location) { return !_this.isSchengenCountry(location.countryCode) && !_this.isEUCountry(location.countryCode); });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.verifyIfCanadaOrColombia = function () {
        return this.locations.some(function (location) { return (Object.is(location.countryCode, COUNTRY_CODE_CANADA)) || (Object.is(location.countryCode, COUNTRY_CODE_COLOMBIA)); });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.isEUCountry = function (countryCode) {
        return this.euCountryCodes.some(function (x) { return Object.is(x.code, countryCode); });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.isSchengenCountry = function (countryCode) {
        return this.schengenCountryCodes.some(function (x) { return Object.is(x.code, countryCode); });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.formPersonalDocumentsErrors = function (control) {
        var errors = [];
        if (Object.is('docType', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocDocumentTypeRequired');
            }
        }
        if (Object.is('docNum', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocDocumentNumRequired');
            }
            if (this.form.controls[control].hasError('pattern')) {
                errors.push('bookingDetails.error.personalDocDocumentNumPattern');
            }
        }
        if (Object.is('country', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocIssuingCountryRequired');
            }
        }
        if (Object.is('nationallity', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocNationalityRequired');
            }
        }
        if (Object.is('gender', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocGenderRequired');
            }
        }
        if (Object.is('stateOrProvinceCode', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocStateRequired');
            }
        }
        if (Object.is('address', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocAddressRequired');
            }
            if (this.form.controls[control].hasError('pattern')
                || this.form.controls[control].hasError('whitespace')) {
                errors.push('bookingDetails.error.personalDocAddressInvalid');
            }
        }
        if (Object.is('postalCode', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocZipCodeRequired');
            }
            if (this.form.controls[control].hasError('pattern')
                || this.form.controls[control].hasError('whitespace')) {
                errors.push('bookingDetails.error.personalDocZipCodeInvalid');
            }
        }
        if (Object.is('city', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocCityRequired');
            }
            if (this.form.controls[control].hasError('whitespace')) {
                errors.push('bookingDetails.error.personalDocCityInvalid');
            }
        }
        if (Object.is('redress', control)) {
            if (this.form.controls[control].hasError('maxLength')) {
                errors.push('bookingDetails.error.personalDocRedressMaxLength');
            }
            if (this.form.controls[control].hasError('pattern')) {
                errors.push('bookingDetails.error.personalDocRedressPattern');
            }
        }
        if (Object.is('birthDate', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocFullBirthDateRequired');
            }
        }
        if (Object.is('expiryDate', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.personalDocFullExpiryDateRequired');
            }
        }
        return errors.join('; ');
    };
    PassengerDetailPersonalDocumentsComponent.prototype.clearForm = function () {
        this.form.reset({ emitEvent: false });
    };
    PassengerDetailPersonalDocumentsComponent.prototype.cancelEdit = function () {
        var _this = this;
        this.store.select(fromStore.getSelectedPassengersAtIndex)
            .pipe(take(1)).subscribe(function (data) {
            var document = _this.getDocumentData(data);
            _this.form.reset(__assign({}, _this.getFormObject(document, data)), { emitEvent: false });
            _this._hasChanges.next(false);
        });
        this.store.dispatch(new fromStore.UpdateFormChangedAction({
            'updateDocument': false,
            'updateRedress': false,
            'updateDoca': false
        }));
        this.displayMode = 'view';
    };
    PassengerDetailPersonalDocumentsComponent.prototype.openEditForm = function () {
        this.displayMode = 'edit';
    };
    PassengerDetailPersonalDocumentsComponent.prototype.INDRA_getCountryCodesOptions = function (countryCodes) {
        var _this = this;
        var options = countryCodes.map(function (item) { return ({
            value: item.value,
            text: _this.INDRA_getTranslation(item.text)
        }); });
        options.sort(function (a, b) { return a.text.localeCompare(b.text); });
        return options;
    };
    PassengerDetailPersonalDocumentsComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    PassengerDetailPersonalDocumentsComponent.prototype.INDRA_checkValidations = function () {
        // if any of these forms were filled by user, require the other fields to ensure complete document 
        // details to be sent as request to back-end 
        if (this.form.get('docType').value ||
            this.form.get('docNum').value ||
            this.form.get('expiryDate').value ||
            this.form.get('lifelong').value ||
            this.form.get('country').value) {
            this.form.get('docType').setValidators([Validators.required]);
            this.form.get('docNum').setValidators([Validators.required]);
            this.form.get('country').setValidators([Validators.required]);
            this.form.get('nationallity').setValidators([Validators.required]);
            this.form.get('docType').updateValueAndValidity({ emitEvent: false });
            this.form.get('docNum').updateValueAndValidity({ emitEvent: false });
            this.form.get('country').updateValueAndValidity({ emitEvent: false });
            this.form.get('nationallity').updateValueAndValidity({ emitEvent: false });
            if (!this.form.get('lifelong').value) {
                this.form.get('expiryDate').setValidators([Validators.required]);
                this.form.get('expiryDate').updateValueAndValidity({ emitEvent: false });
            }
        }
        else {
            this.updateFormValidation();
        }
    };
    return PassengerDetailPersonalDocumentsComponent;
}());
export { PassengerDetailPersonalDocumentsComponent };
